/**
 * Created by kellermaca on 7/08/17.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import resource from 'vue-resource'
import getters from './getters/getters'
import actions from './actions/actions'
import mutations from './mutations/mutations'

Vue.use(resource)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    is_authenticated: false,
    error_authenticate: false,
    messageerror: '',
    messageactual: '',
    messagesuccess: '',
    error: false,
    success: false,
    editcompra: false,
    eliminando: false,
    compras: [],
    compra: {
      fecha_facturacion: '',
      fecha_ingreso: '',
      numerodocumento: null,
      credito: 'false',
      pagada: 'true',
      proveedor: '',
      serie: '',
      cantidad: '',
      totalc: 0
    },
    lineacompra: {
      compra: {detallescompratemporal: []},
      producto: '',
      cantidad: '',
      precio: '',
      precio_compra: '',
      presentacion: 7,
      fecha_vencimiento: ''},

    dialog: false,
    vehiculo: '',
    error_cliente: false,
    has_factura: false,
    has_cotizacion: false,
    fcantidad: 1,
    producto: {presentacion: '', barra: '', producto: 'producto'},
    facturas: [],
    cotizaciones: [],
    clientes: [],
    rutas: [],
    bancos: [],
    usuarios: [],
    proveedores: [],
    vehiculos: [],
    lineas: [],
    lineascotizacion: [],
    listado: {lista: {}},
    factura: {usuario: { username: '' }, credito: false, id: 1},
    kilometrajes: [],
    kilometrajesvendedor: [],
    akilometraje: {'fecha': '', 'kilometraje': '', 'vehiculo': {}, 'kilometraje_inicial': '', 'total_facturas': 0, 'comentario': ''},
    akilometrajevendedor: { 'kilometraje_inicial': '', 'kilometraje_final': '', 'usuario': '' },
    list_headers: [],
    cliente: { nit: null,
      nombre: null,
      direccion: null,
      referencia: null,
      municipio: null,
      departamento: null,
      correo: null,
      telefono: null,
      orden: 0,
      dia: 1,
      semana: 1,
      latitud: '',
      longitud: '',
      avenida: '',
      calle: '',
      zona: '',
      barrio_aldea: '',
      colonia_caserio: ''
    },
    clientecotizacion: {cliente: ''},
    presentaciones: [],
    listadopresentacion: [],
    idsfacturas: [],
    devoluciones: {productos: []},
    lineanota: {},
    guardando: false,
    presentacion: {},
    productos: [],
    dia: null,
    ruta: {nombre: null},
    usuario: {username: null},
    semana: null,
    desde: null,
    hasta: null,
    tipo: '',
    vender_bodega: false,
    extracciones: [],
    tiposextracciones: [],
    activadorcliente: true,
    caja: {}
  },
  mutations: mutations,
  actions: actions,
  getters: getters
})




// WEBPACK FOOTER //
// ./src/store/store.js